module.exports = __webpack_public_path__ + "assets/PTM75F_W.78f6936ca19f3d5164442481a675e6388b135a322a8c1930ac0910bd508aad56.woff2";